import { PUBLIC_ROUTES } from "./constants/orgConstants";

export const browserIdleCallback = (callback) => {
    if(typeof callback !== "function") {
        throw new Error("Provided callback is not a function");
    }

    if("requestIdleCallback" in window) {
        requestIdleCallback(callback);
    }
    else {
        // fallback for safari browser and when browser is not idle (executing at a delay of 3 seconds)
        setTimeout(callback, 3000);
    }
}

export const isPublicRoute = (path) => PUBLIC_ROUTES.some((r) => r.test(path));